import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button } from "antd";

function NewPin() {
  const [error, setError] = useState<string>("");
  const [newForm] = Form.useForm();
  const history = useHistory();

  const onSubmitHandler = (values: any) => {
    console.log(values);
  };

  return (
    <div className="page-container auth-page">
      <Form
        className="auth-form"
        name="new-form"
        id="new-form"
        layout="vertical"
        form={newForm}
        onFinish={onSubmitHandler}
        requiredMark={false}
      >
        <img
          alt="1"
          src="/images/back.png"
          className="back-btn"
          onClick={() => history.goBack()}
        />
        <h3>New PIN</h3>
        <p>Please enter your data here</p>
        <Form.Item
          name="pin"
          rules={[{ required: true, message: "**Required Field" }]}
        >
          <Input type="text" placeholder="Add New PIN" />
        </Form.Item>
        <Form.Item>
          <p className="info-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam,
            purus sit amet luctus venenatis.
          </p>
        </Form.Item>
        <Form.Item
          name="pin2"
          rules={[{ required: true, message: "**Required Field" }]}
        >
          <Input type="text" placeholder="New PIN Again" />
        </Form.Item>
        {error && (
          <Form.Item>
            <p className="error">{error}</p>
          </Form.Item>
        )}
        <Form.Item>
          <Button type="primary" htmlType="submit" onClick={() => setError("")}>
            Save New PIN
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default NewPin;
